import React from 'react';

import { default as DefaultTable, TableProps } from '@/src/components/common/Elements/Table/Table';

const Table = (props: TableProps) => {
  return <DefaultTable {...props} />;
};

export default Table;
